import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/error.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "main-content d-flex flex-column p-0" }
const _hoisted_3 = { class: "m-auto text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          class: "mw-430 mb-4 w-100",
          alt: "error"
        }, null, -1 /* HOISTED */)),
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "fs-24 mb-3" }, " Looks like we did not find this page, please try again later. ", -1 /* HOISTED */)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-4" }, " But no worries! Our team is looking ever where while you wait safely. ", -1 /* HOISTED */)),
        _createVNode(_component_RouterLink, {
          to: "/dashboard",
          class: "btn btn-primary py-2 px-4 fs-16 fw-medium"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "d-inline-block py-1" }, "Back To Home", -1 /* HOISTED */)
          ])),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}